import { useTranslation } from 'react-i18next';
import { PageTitleKeys, pageDescriptions } from '../config/routeConstants';
import { useMetaDescription } from './useMetaDescription';

export const usePageDescription = (key: PageTitleKeys) => {
  const { t } = useTranslation();
  const descKey = pageDescriptions[key] || pageDescriptions[PageTitleKeys.Default];
  const translated = t(descKey) || t(pageDescriptions[PageTitleKeys.Default]);

  useMetaDescription(translated);
};
